export default __webpack_public_path__ + "static/media/TOBA_New.760d315a.pdf";